import { apiClient } from '@/lib/api-client';
import { Company } from '@/models/company';

class CompaniesService {
  async getCompanies(): Promise<Company[]> {
    const companies = await apiClient.get<Company[]>(
      '/api/Companies/GetCompaniesForUser'
    );
    
    if (!companies) return [];
    return companies.map((c) => ({
      ...c,
      Expiration: c.Expiration ? new Date(c.Expiration) : null,
    }));
  }
}

export const companiesService = new CompaniesService();
